
import { Link } from "wouter";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
import { cn } from "@/lib/utils";

type UserProfileLinkProps = {
  userId: number;
  username: string;
  children: React.ReactNode;
  className?: string;
  showTooltip?: boolean;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
};

export function UserProfileLink({ 
  userId, 
  username, 
  children, 
  className = "",
  showTooltip = false,
  tooltipPlacement = "top"
}: UserProfileLinkProps) {
  // Make sure userId is treated as a number and converted to string for the URL
  const profileUrl = `/profile?id=${Number(userId)}`;
  
  if (showTooltip) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={300}>
          <TooltipTrigger asChild>
            <Link href={profileUrl} className={cn("cursor-pointer transition-opacity hover:opacity-90", className)}>
              {children}
            </Link>
          </TooltipTrigger>
          <TooltipContent 
            side={tooltipPlacement} 
            className="bg-black/90 border-white/10 text-white text-xs px-3 py-1.5"
          >
            View {username}'s profile
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return (
    <Link 
      href={profileUrl} 
      className={cn("cursor-pointer transition-all hover:opacity-90", className)}
    >
      {children}
    </Link>
  );
}
